export default __webpack_public_path__ + "b1727db8f7622a3012ef6c65d7ba39f5.png";